import React, { Component } from "react";
import PaginaToolbar from "../../components/PaginaToolbar";
import { criarSetorAtendimentoProtocoloDs } from "../../DataSources.js";
import {
  DataGrid,
  FilterRow,
  StateStoring,
  Editing,
  Column,
  Paging,
  Pager,
} from "devextreme-react/data-grid";
import uiInfo from "../../ui-info";

const localStorageKey = "cadastroSetorAtendimentoProtocoloGridState";

export default class SetorAtendimentoProtocoloBox extends Component {
  constructor(props) {
    super(props);
    this.setorAtendimentoProtocoloDs = criarSetorAtendimentoProtocoloDs();
    this.usadoComoPesquisa = props.onSelecionado !== undefined;
    this.onAtualizandoRow = this.onAtualizandoRow.bind(this);
    this.onSelecionado = props.onSelecionado;
  }

  onAtualizandoRow(e) {
    e.cancel = true;
    this.props.history.push("setoratendimentoprotocolo/editar/" + e.data.id);
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <PaginaToolbar
            titulo="Setor de Atendimento de Protocolo"
            novoCb={this.novoSetorAtendimentoProtocolo.bind(this)}
          >
            <DataGrid
              ref={(grid) => (this._gridInstance = grid)}
              dataSource={this.setorAtendimentoProtocoloDs}
              showBorders={true}
              rowAlternationEnabled={true}
              remoteOperations={true}
              columnAutoWidth={true}
              columnHidingEnabled={true}
              wordWrapEnabled={window.innerWidth < 800}
              filterSyncEnabled={true}
              onEditingStart={this.onAtualizandoRow}
              columnMinWidth
            >
              <StateStoring
                enabled={true}
                type={"localStorage"}
                storageKey={localStorageKey}
              />
              <FilterRow visible={true} />
              <Editing
                allowDeleting={!this.usadoComoPesquisa}
                allowUpdating={!this.usadoComoPesquisa}
                useIcons={true}
                visible={!this.usadoComoPesquisa}
              />
              <Column dataField={"sequencial"} alignment={"left"} />
              <Column dataField={"nome"} alignment={"left"} />
              <Column
                type="buttons"
                fixed={true}
                fixedPosition={"left"}
                buttons={[
                  "edit",
                  "delete",
                  {
                    hint: "Selecionar",
                    icon: "repeat",
                    visible: this.usadoComoPesquisa,
                    onClick: this.onSelecionado,
                  },
                ]}
              />

              <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />

              <Pager
                showInfo={true}
                showNavigationButtons={true}
                showPageSizeSelector={true}
                allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
              />
            </DataGrid>
          </PaginaToolbar>
        </div>
      </React.Fragment>
    );
  }

  novoSetorAtendimentoProtocolo() {
    let gridState = this._gridInstance.instance.state();
    localStorage.setItem(localStorageKey, JSON.stringify(gridState));
    this.props.history.push("setoratendimentoprotocolo/novo");
  }
}
